import {
  EndpointNames,
  Pages,
  RequestMethod
} from '@vio/debug-panel/src/types/enums'
import {ScenarioMetadata} from '@vio/debug-panel/src/types/types'

export const metadata: ScenarioMetadata = {
  scope: 'permanent',
  name: 'Rooms Offers simulation',
  value: 'Rooms',
  description: 'Scenarios for testing rooms-offers endpoint',
  routes: [
    {
      endpoint: EndpointNames.Rooms,
      method: RequestMethod.GET,
      page: Pages.SRP,
      variations: [
        {
          value: 'withSplitBooking',
          displayName: 'Rooms offers with Split Booking',
          description: 'Rooms response also includes splitBooking object'
        },
        {
          value: 'withMergedSplitBooking',
          displayName: 'Rooms offers with merged Split Booking',
          description:
            'splitBooking object includes merged cancellationPenalties'
        },
        {
          value: 'withSusiLockedOfferSRP',
          displayName: 'Clicked room, SUSI locked SRP',
          description:
            'Takes first offer from the response, marks it as clicked and sets props to lock it with SUSI auth flow (private deal)'
        },
        {
          value: 'withSMSLockedOfferSRP',
          displayName: 'Clicked room, SMS locked SRP',
          description:
            'Takes first offer from the response, marks it as clicked and sets props to lock it with SMS auth flow'
        }
      ]
    },
    {
      endpoint: EndpointNames.Rooms,
      method: RequestMethod.GET,
      page: Pages.AP,
      variations: [
        {
          value: 'withSplitBooking',
          displayName: 'Rooms offers with Split Booking',
          description: 'Rooms response also includes splitBooking object'
        },
        {
          value: 'clickedOfferIsSMS',
          displayName: 'Rooms offers with clicked offer as SMS',
          description: 'Rooms response includes clicked offer as SMS'
        },
        {
          value: 'withSusiLockedOfferAP',
          displayName: 'Clicked room, SUSI locked AP',
          description:
            'Takes first offer from the response, marks it as clicked and sets props to lock it with SUSI auth flow (private deal)'
        },
        {
          value: 'withSMSLockedOfferAP',
          displayName: 'Clicked room, SMS locked AP',
          description:
            'Takes first offer from the response, marks it as clicked and sets props to lock it with SMS auth flow'
        },
        {
          value: 'clickedNotCheapestRegular',
          displayName: 'Clicked room offer is not the cheapest',
          description:
            'Rooms response includes clicked offer which is not the cheapest one'
        },
        {
          value: 'clickedNotCheapestSb',
          displayName: 'Clicked SB offer is not the cheapest',
          description:
            'Rooms response includes SB clicked offer which is not the cheapest one'
        },
        {
          value: 'withMergedSplitBooking',
          displayName: 'Rooms offers with merged Split Booking',
          description:
            'splitBooking object includes merged cancellationPenalties'
        },
        {
          value: 'soldOut',
          displayName: 'Rooms offers with no rooms availibility',
          description: 'No rooms found for the selected offers'
        },
        {
          value: 'clickedOffer',
          displayName: 'Rooms offers with clicked offer',
          description: 'Rooms response includes clicked offer'
        }
      ]
    }
  ]
}
